<template>
  <div>
    <!-- <b-card
      class="mb-2 shadow"
      header="Statistiques du créancier"
      bg-variant="secondary"
      header-text-variant="light"
      header-tag="h6"
    > -->
      <template v-if="loaded">
        <b-row>
          <b-col lg="2">
            <label>Année de départ</label>
            <b-select v-model="range.start" @change="checkDate()">
              <b-select-option
                v-for="year in full_range.end - full_range.start + 1"
                :key="year"
                :value="year - 1 + full_range.start"
                >{{ year - 1 + full_range.start }}</b-select-option
              >
            </b-select>
          </b-col>
          <b-col lg="2">
            <label>Année de fin</label>
            <b-select v-model="range.end" @change="checkDate()">
              <b-select-option
                v-for="year in full_range.end - range.start + 1"
                :key="year"
                :value="year - 1 + range.start"
                >{{ year - 1 + range.start }}</b-select-option
              >
            </b-select>
          </b-col>
          <b-col lg="2" >
            <table class="table table-striped table-sm table-hover table-bordered mt-3">
              <tr class="text-center">
                <td>Nombre de mandats</td>
                <td>{{ creditor.stats.totaux.n_mandats }}</td>
              </tr>
              <tr class="text-center">
                <td>Nombre de débiteurs</td>
                <td>{{ creditor.stats.totaux.n_debiteurs }}</td>
              </tr>
            </table>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6" class="mt-2">
            <highcharts
              :options="chart_purchase"
              ref="chart_purchase"
            ></highcharts>
          </b-col>
          <b-col lg="6" class="mt-2">
            <highcharts
              :options="chart_warrants"
              ref="chart_warrants"
            ></highcharts>
          </b-col>
          <b-col lg="6" class="mt-2">
            <highcharts
              :options="chart_recuperation"
              ref="chart_recuperation"
            ></highcharts>
          </b-col>
          <b-col lg="6" class="mt-2">
            <highcharts
              :options="chart_rate"
              ref="chart_rate"
            ></highcharts>
          </b-col>
        </b-row>
      </template>
    <!-- </b-card> -->
  </div>
</template>

<script>
//import DateTime from "@/services/DateTime.js";
import creditors from "@/services/creditors.js";
import { Chart } from "highcharts-vue";
export default {
  name: "creditor-stats",
  components: {
    highcharts: Chart,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    active: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      creditor: {},
      loaded: false,
      range: {
        start: null,
        end: null,
      },
      full_range: {
        start: null,
        end: null,
      },
      chart_purchase: {},
      chart_warrants: {},
      chart_recuperation: {},
      chart_rate: {}
    };
  },
  created() {
    this.load();
  },
  methods: {
    checkDate() {
      if (this.range.start > this.range.end) {
        this.range.end = this.range.start;
      }
      this.reload(this.range);
    },
    reload() {
      creditors
        .getStatsRange(this.$props.id, this.range.start, this.range.end)
        .then((response) => {
          this.creditor = response.data;
          this.createCharts();
          this.loaded = true;
        });
    },
    load() {
      creditors.getStats(this.$props.id).then((response) => {
        this.creditor = response.data;
        this.full_range = this.creditor.stats.range;
        this.range.start = this.full_range.start;
        this.range.end = this.full_range.end;
        this.createCharts();

        this.loaded = true;
      });
    },
    createCharts() {
      this.chart_purchase = {
        chart: {
          zommType: "xy",
        },
        title: {
          text: "Nombre de mandats achetés sur la période",
        },
        xAxis: {
          categories: this.creditor.stats.n_purchases.map((x) => x.year),
          tickmarkPlacement: "on",
          title: {
            enabled: false,
          },
        },
        yAxis: [
          {
            title: {
              text: "Nombre de mandats",
            },
          },
          {
            title: {
              text: "Nombre de carnets",
            },
            opposite: true,
          },
        ],
        tooltip: {
          split: true,
          pointFormat: "{series.name}: {point.y}",
        },
        plotOptions: {
          area: {
            stacking: "normal",
            lineColor: "#666666",
            lineWidth: 1,
            marker: {
              lineWidth: 1,
              lineColor: "#666666",
            },
          },
        },
        series: [
          {
            name: "Mandats",
            type: "spline",
            data: this.creditor.stats.n_purchases.map((x) => x.mandats),
          },
          {
            name: "Carnets",
            type: "column",
            yAxis: 1,
            data: this.creditor.stats.n_purchases.map((x) => x.carnets),
          },
        ],
      };
      this.chart_warrants = {
        chart: {
          type: "column",
        },
        title: {
          text: "Mandats créés, ouverts et clôturés",
        },
        xAxis: {
          categories: this.creditor.stats.n_warrants.map((x) => x.year),
          tickmarkPlacement: "on",
          title: {
            enabled: false,
          },
        },
        yAxis: {
          title: {
            text: "Nombre de mandats",
          },
        },
        tooltip: {
          split: true,
          pointFormat: "{series.name}: {point.y}",
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: "Mandats créés",
            data: this.creditor.stats.n_warrants.map((x) => x.created),
          },
          {
            name: "Mandats ouverts",
            data: this.creditor.stats.n_warrants.map((x) => x.opened),
          },
          {
            name: "Mandats clôturés",
            data: this.creditor.stats.n_warrants.map((x) => x.closed),
          },
          {
            name: "Mandats ouverts et clôturés la même année",
            data: this.creditor.stats.n_warrants.map((x) => x.both),
          },
        ],
      };
      this.chart_recuperation = {
        chart: {
          type: "column",
        },
        title: {
          text: "Soldes et récupérations",
        },
        xAxis: {
          categories: this.creditor.stats.factures.map((x) => x.year),
          tickmarkPlacement: "on",
          title: {
            enabled: false,
          },
        },
        yAxis: {
          title: {
            text: "Montant",
          },
        },
        tooltip: {
          split: true,
          pointFormat: "{series.name}: {point.y} €",
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: "Solde",
            data: this.creditor.stats.factures.map((x) => x.solde),
          },
          {
            name: "Montant récupéré",
            data: this.creditor.stats.factures.map((x) => x.payement),
          }
        ],
      };
            this.chart_rate = {
        chart: {
          type: "column",
        },
        title: {
          text: "Taux de récupération",
        },
        xAxis: {
          categories: this.creditor.stats.taux_recup.map((x) => x.year),
          tickmarkPlacement: "on",
          title: {
            enabled: false,
          },
        },
        yAxis: {
          title: {
            text: "Taux (%)",
          },
        },
        tooltip: {
          split: true,
          pointFormat: "{series.name}: {point.y} %",
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: "Taux de récupération",
            data: this.creditor.stats.taux_recup.map((x) => x.taux),
          }
        ],
      };
    },
  },
};
</script>